var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentsBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#059669",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22, 30) rotate(-10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8 L18 0 L36 8 L18 16 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12 L6 22 Q18 26 30 22 L30 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 9,
    x2: 34,
    y2: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 26,
    r: 1.8,
    fill: "#059669"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112, 22) rotate(8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L14 3 L14 24 L0 21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3 L28 0 L28 21 L14 24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 3,
    x2: 14,
    y2: 24
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(196, 28) rotate(35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L5 0 L5 26 L2.5 32 L0 26 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 6,
    x2: 5,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 22,
    x2: 5,
    y2: 22
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38, 108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0 Q0 0 0 10 Q0 16 5 19 L5 26 L15 26 L15 19 Q20 16 20 10 Q20 0 10 0 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 28,
    x2: 15,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 30,
    x2: 13,
    y2: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(118, 112)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.2,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 16,
    ry: 6,
    transform: "rotate(30 12 12)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 16,
    ry: 6,
    transform: "rotate(-30 12 12)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 16,
    ry: 6,
    transform: "rotate(90 12 12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192, 106)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 28,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 16,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 14.5,
    r: 1.6,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 14.5,
    r: 1.6,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.5,
    r: 1.6,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 20,
    r: 1.6,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 20,
    r: 1.6,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 20,
    r: 1.6,
    fill: "#059669"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 188) rotate(-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8 Q2 2 8 2 L22 2 Q28 2 28 8 L28 30 L2 30 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2 Q11 -2 15 -2 Q19 -2 19 2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 16,
    height: 8,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112, 192)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 13,
    rx: 5.5,
    ry: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 13,
    x2: 26,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 0,
    x2: 13,
    y2: 26
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(188, 190) rotate(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5 L20 5 L20 14 Q20 18 24 18 Q28 18 28 14 L28 0 L8 0 Q4 0 4 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 5,
    x2: 0,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 14,
    y2: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsBg);
export default __webpack_public_path__ + "static/media/students-bg.a877b72b8e5a1ec9b7bdd4df6c683f3a.svg";
export { ForwardRef as ReactComponent };